<template>
  <div class="animated fadeIn personal-novedades-calendario">
    <b-row>
      <b-col cols="12" xl="12">
        <app-filtro
          :fechaDesde="fechaDesdeParam"
          :fechaHasta="fechaHastaParam"
          :tipoNovedad="tipoNovedad"
          :personal="personal"
          @filtrar="filtrar">
        </app-filtro>  
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
          <b-card header="Novedades del Personal">
            <div class="at-eg">
              <div class="at-eg-bd">
                <table class="at-eg-tb at-eg-tasks"
                  :busy="tableBusy">
                  <tbody>
                    <div class="at-eg-dates" >
                      <tr>
                        <td class="at-eg-cell-a">#</td>
                        <td class="at-eg-cell-a-b"></td>
                        <td v-for="date in periodo" :key="date">
                          <div class="at-eg-cell-b">{{ date | mes_dia }}</div>
                        </td>
                      </tr>
                    </div>
                    <div v-for="(obj, idx) in novedades" :key="idx">
                      <app-tasks :user="obj.user" 
                        :tasks="obj.tasks"
                        :total="obj.total" 
                        :dates="periodo" 
                        :cls="idx % 2 === 0 ? 'at-eg-odd' : ''">
                      </app-tasks>
                    </div>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="referencias">
              <div v-for="(tipoFalta, index) in tiposNovedades" :key="index">
                <div 
                  :style='"background-color: " + tipoFalta.color + ";"'></div>
                <p :id="tipoFalta.nombre" >{{ tipoFalta.nombre }}</p>
              </div>
            </div>
          </b-card>
        </transition>
      </b-col>
    </b-row>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<style lang="stylus" src="../../assets/scss/gannt.styl"></style>

<script>
import Filtro from './listFiltro.vue';
import Tasks from './ganntTasks.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs';
import moment from 'moment';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'personalNovedadesCalendario/getField',
  mutationType: 'personalNovedadesCalendario/updateField',
});


export default {
  name: 'PersonalNovedadesCalendario',
  components: {
    appTasks: Tasks,
    appFiltro: Filtro,
    appMensaje: Mensaje
  },
  mixins: [
    msjModal
  ],
  data() {
    return {
      spinnerClass: 'at-eg-spinner-default',
      tableBusy: true,

      tiposNovedades: [],
    }
  },
  computed: {
    ...mapFields([
      'novedades',
      'periodo',
      'fechaDesde',
      'fechaHasta',
      'tipoNovedad',
      'personal'
    ]),
    fechaDesdeParam() {
      return moment.utc(this.fechaDesde).format('YYYY-MM-DD');
    },
    fechaHastaParam() {
      return moment.utc(this.fechaHasta).format('YYYY-MM-DD');
    },
  },
  created() {
    this.getDatosAdicionales();

    this.getItems();
  },
  methods: {
    filtrar(filtro) {
      this.fechaDesde = filtro.fechaDesde;
      this.fechaHasta = filtro.fechaHasta;
      this.tipoNovedad = filtro.tipoNovedad;
      this.personal = filtro.personal;

      this.getItems();  
    },
    getItems() {
      this.tableBusy = true;
      this.showSpinner();
      this.$store.dispatch('personalNovedadesCalendario/getPersonalNovedades')
        .then(() => this.tableBusy = false)
        .catch( error => this.showErrorMsj (error))
        .finally(() => this.hideSpinner());
    },
    getDatosAdicionales() {
      this.$store.dispatch('tiposNovedades/getList')
        .then(() => this.tiposNovedades = this.$store.getters['tiposNovedades/list'])
    },
  },
  watch: {
  }    
}
</script>

<style>
  /*
  .at-eg-task-inner div {
    background-color: red;
    height: 100%;
  }
  */
  .at-eg-date {
    font-size: 12px;
    width: 50px !important;
    min-width: 50px !important;
    max-width: 50px !important;
    padding-left: 3px;
    padding-right: 3px;
    overflow: hidden;
  }
  .at-eg-username {
    text-align: left !important;
    overflow: hidden;
    white-space: nowrap;
    margin-top: 5px;
    margin-bottom: 5px;
  }
  .at-eg-username.x2 {
    height: 60px;
  }
  .at-eg-username.x3 {
    height: 90px;
  }
  .at-eg-username.x4 {
    height: 120px;
  }
  .at-eg-username.x5 {
    height: 150px;
  }
  .at-eg-username.x6 {
    height: 180px;
  }
  .at-eg-username.x7 {
    height: 210px;
  }
  .at-eg-username.x8 {
    height: 240px;
  }
  .at-eg-username.x9 {
    height: 270px;
  }
  .at-eg-username.x10 {
    height: 300px;
  }

  .at-eg-username p {
    font-size: 12px;
    margin: 0;
    white-space: nowrap;
  }
  .at-eg-dates td {
    padding: 0;
    padding-right: 1px;
    width: 50px;
    max-width: 50px;
    min-width: 50px;
    text-align: center;
  }
  .at-eg-dates .at-eg-cell-a,
  .at-eg-dates .at-eg-cell-a-b {
    width: 150px;
    max-width: 150px;
    min-width: 150px;
    /*border-left: 1px solid #c8ced3;*/
  }
  .at-eg-dates .at-eg-cell-a,
  .at-eg-cell-a {
    position: absolute;
    background-color: white;
    /*background-color: #f0f3f5;*/
    z-index: 999;
    /*padding-left: 5px;*/
  }
  .at-eg-dates .at-eg-cell-a {
    background-color: white;
    color: white;
    /*color: #f0f3f5;*/
  }
  .at-eg-cell-a-b {
    width: 150px;
    max-width: 150px;
    min-width: 150px;
  }
  /* .at-eg-cell-b {
    border: none;
  } */
  table.at-eg-tasks tbody > div:last-of-type {
    margin-bottom: 20px;
  }

  /* .at-eg-cell-a-b.x5{
    position: absolute;
    background-color: red;
    height: 120px;
    top: 120px;
    z-index: 9999;
  } */
  .personal-novedades-calendario div.referencias {
    position: relative;
    margin-top: 30px;
  }
  .personal-novedades-calendario div.referencias > div > div {
    display: inline-block;
    position: relative;
    margin-right: 5px;
    width: 12px; 
    height: 12px; 
    top: 2px;
  }
  .personal-novedades-calendario div.referencias > div > p {
    display: inline-block;
    font-size: 10px;
    margin-bottom: 5px;
  }
</style>
